var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUploadCloud(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20418_20310)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3326 13.3334L9.99923 10M9.99923 10L6.6659 13.3334M9.99923 10V17.5M16.9909 15.325C17.8037 14.8819 18.4458 14.1808 18.8158 13.3322C19.1858 12.4837 19.2627 11.5361 19.0344 10.6389C18.8061 9.74182 18.2855 8.94629 17.5548 8.3779C16.8241 7.80951 15.925 7.50064 14.9992 7.50003H13.9492C13.697 6.5244 13.2269 5.61864 12.5742 4.85085C11.9215 4.08307 11.1033 3.47324 10.181 3.0672C9.2587 2.66116 8.25636 2.46949 7.24933 2.5066C6.2423 2.5437 5.25679 2.80861 4.36688 3.28142C3.47697 3.75422 2.70583 4.42261 2.11142 5.23635C1.51701 6.05008 1.11481 6.98797 0.935051 7.97952C0.755293 8.97107 0.802655 9.99047 1.07358 10.9611C1.3445 11.9317 1.83194 12.8282 2.49923 13.5834",
    stroke: "#475467",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20418_20310"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadCloud);
export default __webpack_public_path__ + "static/media/upload-cloud.42ff9d3836005a8ae90fc9948bacd004.svg";
export { ForwardRef as ReactComponent };